import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  apidata = [],
  columns,
  searchBy,
}) {
  const [dataFilter, setDataFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [filterOptions, setFilterOptions] = useState({
    month: "",
    year: "",
    documentType: "",
    client: "", // ✅ NEW
    leasingPartner: "", // ✅ NEW
  });

  // ✅ UNIQUE DOCUMENT TYPES
  const uniqueDocumentTypes = useMemo(() => {
    return [
      ...new Set(
        apidata.map((item) => item?.documenttypeId?.name).filter(Boolean),
      ),
    ];
  }, [apidata]);

  // ✅ UNIQUE CLIENTS
  const uniqueClients = useMemo(() => {
    return [
      ...new Set(apidata.map((item) => item?.clientId?.name).filter(Boolean)),
    ];
  }, [apidata]);

  // ✅ UNIQUE LEASING PARTNERS
  const uniqueLeasingPartners = useMemo(() => {
    return [
      ...new Set(
        apidata.map((item) => item?.leaseId?.leasing_partner).filter(Boolean),
      ),
    ];
  }, [apidata]);

  // ✅ ✅ ✅ MAIN FILTER LOGIC (ONLY ONE useEffect — CLEAN)
  useEffect(() => {
    let filtered = [...apidata];

    // 🔍 SEARCH (Vehicle Number)
    // 🔍 MULTI-FIELD SEARCH
    if (dataFilter) {
      const searchValue = dataFilter.toLowerCase();

      filtered = filtered.filter((item) => {
        const vehicleNumber = item?.vehicleId?.numberplate?.toLowerCase() || "";

        const clientName = item?.clientId?.name?.toLowerCase() || "";

        const leasingPartner =
          item?.leaseId?.leasing_partner?.toLowerCase() || "";

        return (
          vehicleNumber.includes(searchValue) ||
          clientName.includes(searchValue) ||
          leasingPartner.includes(searchValue)
        );
      });
    }

    // 🗓️ MONTH & YEAR FILTER
    if (filterOptions.month || filterOptions.year) {
      filtered = filtered.filter((item) => {
        if (!item.Date) return false;

        const date = new Date(item.Date);
        const itemMonth = date.getMonth() + 1;
        const itemYear = date.getFullYear();

        const monthMatch =
          !filterOptions.month || itemMonth === Number(filterOptions.month);

        const yearMatch =
          !filterOptions.year || itemYear === Number(filterOptions.year);

        return monthMatch && yearMatch;
      });
    }

    // ✅ DOCUMENT TYPE FILTER
    if (filterOptions.documentType) {
      filtered = filtered.filter(
        (item) => item?.documenttypeId?.name === filterOptions.documentType,
      );
    }

    // ✅ ✅ CLIENT FILTER
    if (filterOptions.client) {
      filtered = filtered.filter(
        (item) => item?.clientId?.name === filterOptions.client,
      );
    }

    // ✅ ✅ LEASING PARTNER FILTER
    if (filterOptions.leasingPartner) {
      filtered = filtered.filter(
        (item) =>
          item?.leaseId?.leasing_partner === filterOptions.leasingPartner,
      );
    }

    setFilteredData(filtered);
  }, [dataFilter, apidata, searchBy, filterOptions]);

  // ✅ APPLY FILTERS
  const applyFilters = (filters) => {
    console.log("✅ Applied Filters:", filters);
    setFilterOptions(filters);
  };

  // ✅ REMOVE FILTERS
  const removeFilters = () => {
    setFilterOptions({
      month: "",
      year: "",
      documentType: "",
      client: "",
      leasingPartner: "",
    });
  };

  return (
    <div className="table-responsive">
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            placeholder={`Search by vehicle, client, lease`}
            className="form-control"
            value={dataFilter}
            onChange={(e) => setDataFilter(e.target.value)}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
        </div>
      </div>

      {filteredData.length > 0 ? (
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          fixedHeader
          highlightOnHover
          responsive
          paginationPerPage={5}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
        />
      ) : (
        <p className="text-center text-muted mt-3">No results found.</p>
      )}

      {/* ✅ ✅ ✅ FILTER MODAL */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        documentTypes={uniqueDocumentTypes}
        clients={uniqueClients} // ✅ PASS CLIENTS
        leasingPartners={uniqueLeasingPartners} // ✅ PASS PARTNERS
      />
    </div>
  );
}
